'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _class; /* global window */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _mobxReact = require('mobx-react');

var _utils = require('@dekk/utils');

var _store4 = require('@dekk/store');

var _store5 = _interopRequireDefault(_store4);

var _url = require('@dekk/url');

var _wrapper = require('../wrapper');

var _wrapper2 = _interopRequireDefault(_wrapper);

var _slidesWrapper = require('../slides-wrapper');

var _slidesWrapper2 = _interopRequireDefault(_slidesWrapper);

var _plugins = require('../plugins');

var _plugins2 = _interopRequireDefault(_plugins);

var _elements = require('../elements');

var _elements2 = _interopRequireDefault(_elements);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _search$parse = _url.search.parse(window.location.href),
    live = _search$parse.live,
    present = _search$parse.present,
    _search$parse$preview = _search$parse.preview,
    preview = _search$parse$preview === undefined ? null : _search$parse$preview;

/**
 * A wrapper around the slides.
 * `<Deck/>` renders 3 slides (previous, current, next) to allow various
 * transitions.
 *
 * The internal store is handled by mobX. {@link https://github.com/mobxjs/}
 *
 * @class Deck
 * @param {Object} props
 *   The properties
 * @param {(Slide|Slide[]|Elements|Elements[]|Plugins|Plugins[])} props.children
 * @param {(String|Array)} props.mixin
 *
 * @example
 * import React from 'react'
 * import Deck from '@dekk/deck'
 * import Slide from '@dekk/slide'
 *
 * const App = () => (
 *   <Dekk>
 *     <Slide>1</Slide>
 *     <Slide>2</Slide>
 *     <Slide>3</Slide>
 *   </Dekk>
 * )
 */


var Deck = (0, _mobxReact.observer)(_class = function (_Component) {
  _inherits(Deck, _Component);

  _createClass(Deck, null, [{
    key: 'propTypes',


    /**
     * @private
     * @return {{children: (Slide|Slide[]), mixin: ?String, slave: ?Boolean}}
     *   Allowed propTypes for `<Deck/>`
     */
    get: function get() {
      return {
        children: _propTypes2.default.node.isRequired,
        mixin: _propTypes2.default.oneOfType([_propTypes2.default.array, _propTypes2.default.string])
      };
    }

    /**
     * @private
     */

    /**
     * Store.
     * It handles paging and fragmentOrder navigation
     * @private
     */

  }, {
    key: 'defaultProps',
    get: function get() {
      return {
        mixin: ''
      };
    }

    /**
     * Sends context to decendants.
     * Includes the app store to allow all deck components to access the store
     * without having to include its own logic.
     * @private
     * @return {{store: Object, fragmentHost: number}}
     *   The `store` and the `fragmentHost`
     */

  }, {
    key: 'childContextTypes',
    get: function get() {
      return {
        store: _propTypes2.default.object.isRequired,
        fragmentHost: _propTypes2.default.number
      };
    }
  }]);

  function Deck(props) {
    _classCallCheck(this, Deck);

    var _this = _possibleConstructorReturn(this, (Deck.__proto__ || Object.getPrototypeOf(Deck)).call(this, props));

    _this.store = new _store5.default();

    _this.state = {};
    return _this;
  }

  /**
   * @private
   * @return {{store: store}}
   *   The child context.
   */


  _createClass(Deck, [{
    key: 'getChildContext',
    value: function getChildContext() {
      return {
        store: this.store
      };
    }

    /**
     * @private
     */

  }, {
    key: 'componentWillMount',
    value: function componentWillMount() {
      this.buildFragmentHosts(this.props.children);
    }

    /**
     * @private
     */

  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(newProps) {
      // Rebuild fragmentHost when children change
      // this will prevent undefined hosts while reducing the number
      // of calls
      if (newProps.children !== this.props.children) {
        this.buildFragmentHosts(newProps.children);
      }
    }

    /**
     * @private
     */

  }, {
    key: 'buildFragmentHosts',
    value: function buildFragmentHosts(children) {
      var _this2 = this;

      _react.Children.toArray(children).filter(function (child) {
        return !_this2.slots.includes(child.type);
      }).forEach(function (child, index) {
        if (_this2.store.fragmentHosts.length - 1 < index) _this2.store.fragmentHosts[index] = [];
      });
    }

    /**
     * @private
     */

  }, {
    key: 'getPluginsData',
    value: function getPluginsData(slideIndex) {
      var activeSlide = this.slides.find(function (c, i) {
        return i === slideIndex;
      });

      var children = _react.Children.toArray(activeSlide.props.children);
      var pluginsData = children.filter(function (child) {
        return child.type === _plugins2.default.Data;
      });

      var props = pluginsData.reduce(function (obj, el) {
        return _extends({}, obj, el.props);
      }, {});
      return props;
    }
  }, {
    key: 'getElementsData',
    value: function getElementsData(slideIndex) {
      var activeSlide = this.slides.find(function (c, i) {
        return i === slideIndex;
      });

      var children = _react.Children.toArray(activeSlide.props.children);
      var elementsData = children.filter(function (child) {
        return child.type === _elements2.default.Data;
      });

      var props = elementsData.reduce(function (obj, el) {
        return _extends({}, obj, el.props);
      }, {});
      return props;
    }

    /**
     * @private
     * @return {Wrapper}
     *   The entire Deck inside a Wrapper
     */

  }, {
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        _wrapper2.default,
        { mixin: this.props.mixin },
        this.plugins,
        this.elements,
        _react2.default.createElement(
          _slidesWrapper2.default,
          null,
          this.visibleSlides
        )
      );
    }
  }, {
    key: 'plugins',
    get: function get() {
      var _this3 = this;

      var _store = this.store,
          slideIndex = _store.slideIndex,
          fragmentIndex = _store.fragmentIndex,
          fragmentOrder = _store.fragmentOrder;
      var slideCount = this.slides.length;
      var fragmentCount = this.store.fragmentHosts[slideIndex].length;

      return _react.Children.toArray(this.props.children).filter(function (child) {
        return (typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && child.type === _plugins2.default;
      }).filter(function (_ref) {
        var props = _ref.props;
        var _props$mode = props.mode,
            mode = _props$mode === undefined ? [] : _props$mode;
        var length = mode.length;

        for (var i = 0; i < length; i++) {
          if (mode[i] === 'live' && live) {
            return true;
          }
          if (mode[i] === 'preview' && preview !== null) {
            return true;
          }
          if (mode[i] === 'present' && present) {
            return true;
          }
          if (mode[i] === 'default' && !live && !present && preview === null) {
            return true;
          }
        }
        return length === 0;
      }).reduce(function (a, b) {
        return a.concat(b.props.children);
      }, []).filter(Boolean).map(function (plugin, index) {
        return (0, _react.cloneElement)(plugin, _extends({}, _this3.getPluginsData(slideIndex), {
          key: plugin.type.name + '_' + index
        }, _this3.store.publicMethods, {
          slideIndex: slideIndex,
          slideCount: slideCount,
          fragmentIndex: fragmentIndex,
          fragmentCount: fragmentCount,
          fragmentOrder: fragmentOrder
        }));
      });
    }

    /**
     * @private
     */

  }, {
    key: 'elements',
    get: function get() {
      var _this4 = this;

      var _store2 = this.store,
          slideIndex = _store2.slideIndex,
          fragmentIndex = _store2.fragmentIndex,
          fragmentOrder = _store2.fragmentOrder;
      var slideCount = this.slides.length;
      var fragmentCount = this.store.fragmentHosts[slideIndex].length;

      return _react.Children.toArray(this.props.children).filter(function (child) {
        return (typeof child === 'undefined' ? 'undefined' : _typeof(child)) === 'object' && child.type === _elements2.default;
      }).filter(function (_ref2) {
        var props = _ref2.props;
        var _props$mode2 = props.mode,
            mode = _props$mode2 === undefined ? [] : _props$mode2;
        var length = mode.length;

        for (var i = 0; i < length; i++) {
          if (mode[i] === 'live' && live) {
            return true;
          }
          if (mode[i] === 'preview' && preview !== null) {
            return true;
          }
          if (mode[i] === 'present' && present) {
            return true;
          }
          if (mode[i] === 'default' && !live && !present && preview === null) {
            return true;
          }
        }
        return length === 0;
      }).reduce(function (a, b) {
        return a.concat(b.props.children);
      }, []).filter(Boolean).map(function (element, index) {
        return (0, _react.cloneElement)(element, _extends({}, _this4.getElementsData(slideIndex), {
          key: element.type.name + '_' + index
        }, _this4.store.publicMethods, {
          slideIndex: slideIndex,
          slideCount: slideCount,
          fragmentIndex: fragmentIndex,
          fragmentCount: fragmentCount,
          fragmentOrder: fragmentOrder
        }));
      });
    }

    /**
     * @private
     */

  }, {
    key: 'slots',
    get: function get() {
      return [_plugins2.default, _elements2.default];
    }

    /**
     * @private
     */

  }, {
    key: 'slides',
    get: function get() {
      var _this5 = this;

      return _react.Children.toArray(this.props.children).filter(function (child) {
        return !_this5.slots.includes(child.type);
      });
    }

    /**
     * Get the `children` by a range of `+-1` around the current slide.
     * It renders a maximum of 3 slides (previous, current, next)
     * This allows various transitions between slides.
     *
     * @private
     * @return {Array<Slide>} returns an array of max 3 slides
     */

  }, {
    key: 'visibleSlides',
    get: function get() {
      var _store3 = this.store,
          slideIndex = _store3.slideIndex,
          direction = _store3.direction,
          fragmentOrder = _store3.fragmentOrder,
          fragmentHosts = _store3.fragmentHosts;

      return this.slides
      // Assign the original index for the Component
      .map(function (child, originalIndex) {
        return { child: child, originalIndex: originalIndex };
      })
      // Filter by a range of `+-1`
      // Filter first to reduce the number of clones
      // This will not allow us to get all fragments on init but
      // improves performance
      .filter(function (c, i) {
        return (0, _utils.range)(i, slideIndex + 1, slideIndex - 1);
      })
      // Modify the remaining slides (maximum of 3)
      .map(function (_ref3) {
        var child = _ref3.child,
            originalIndex = _ref3.originalIndex;
        var _fragmentHosts$origin = fragmentHosts[originalIndex].length,
            fragmentCount = _fragmentHosts$origin === undefined ? 0 : _fragmentHosts$origin;

        var lastFragment = Math.max(0, fragmentCount - 1);
        // Flags to check for value
        var isCurrent = slideIndex === originalIndex;
        var isPrev = slideIndex === originalIndex + 1;
        var isNext = slideIndex === originalIndex - 1;
        // Flags to check for directional movement
        // Slides could obviously move anywhere but this is something
        // we all understand
        var movesRight = direction === 1;
        var movesLeft = direction === -1;

        // Clone the element to add the logic
        return (0, _react.cloneElement)(child, {
          direction: direction,
          isPrev: isPrev,
          isNext: isNext,
          isCurrent: isCurrent,
          key: 'slide_' + originalIndex,
          fragmentOrder: isCurrent ? fragmentOrder : isPrev ? lastFragment : 0,
          slideIndex: originalIndex,
          fromPrev: isCurrent && movesLeft,
          fromNext: isCurrent && movesRight,
          toPrev: isPrev && movesRight,
          toNext: isNext && movesLeft
        });
      });
    }
  }]);

  return Deck;
}(_react.Component)) || _class;

exports.default = Deck;